import { IPlayer } from '@base/features/player/model/interfaces';

export default function Avatar(props: { player: IPlayer, icon: string}) {
  const { player } = { ...props };
  return (
    <div
      className={`player-info__avatar-wrapper ${
        player.isPlayingTurn() ? 'player-info__avatar-wrapper_active' : ''
      }`}
    >
      <div className="avatar-overlay">
        <img
          className="avatar"
          src={player.avatarUrl() === 'system' ? `assets/avatars/${player.avatar}.png` : player.avatarUrl()}
          alt={player.name}
        />
      </div>
      <img
        className="personal-info__checker"
        src={props.icon}
        alt={player.getName()}
      />
    </div>
  );
}
